import { apiRequest } from './client';

export const submitContactForm = ({ name, email, message }) => apiRequest('/api/v1/contact_form', {
  method: 'POST',
  mode: 'cors',
  body: {
    name,
    email,
    message
  }
});
